// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Lf93","text":"SelectPayment_text__2dSyB","title":"SelectPayment_title__18X5o","btn":"SelectPayment_btn__3T_l-"};